// extracted by mini-css-extract-plugin
export default {"container":"style_container__MGVOv","logout":"style_logout__F8lo0"};